import React from 'react';
import { Link } from 'react-router-dom';
import UnifiedAuthPanel from '../components/UnifiedAuthPanel';

const LoginPage = () => (
  <div className="min-h-screen bg-[#FAFAF7] flex" data-testid="login-page">
    <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 py-12 sm:px-12">
      <div className="mb-8">
        <Link to="/" className="flex items-center gap-3 group" data-testid="auth-logo-link" aria-label="Shopperden home">
          <span aria-hidden="true" className="w-10 h-10 rounded-lg flex items-center justify-center shadow-sm transition-transform duration-200 group-hover:scale-105"
                style={{ background: 'linear-gradient(135deg, #10b981 0%, #0f766e 100%)' }}>
            <svg viewBox="0 0 64 64" className="w-6 h-6" fill="none" stroke="#ffffff" strokeLinejoin="round" strokeLinecap="round">
              <path d="M25 17 Q25 10 32 10 Q39 10 39 17" strokeWidth="2.6" />
              <path d="M14 32 L32 17 L50 32 L50 50 L14 50 Z" strokeWidth="3.6" />
              <path d="M28 50 L28 38 L36 38 L36 50" strokeWidth="3.6" />
            </svg>
          </span>
          <span className="font-['Playfair_Display'] text-xl text-[#0F172A] tracking-wide">
            SHOPPER<span className="text-[#E07A3A]">DEN</span>
          </span>
        </Link>
      </div>
      <UnifiedAuthPanel mode="login" />
    </div>
    <div className="hidden lg:block lg:w-1/2 relative" style={{ background: 'linear-gradient(135deg, #0A0A0C 0%, #1F2937 100%)' }}>
      <div className="absolute inset-0 flex flex-col justify-center px-10 xl:px-16">
        <p className="text-[0.65rem] xl:text-xs tracking-[0.4em] uppercase mb-4 font-semibold" style={{ color: '#D4AF37' }} data-testid="login-eyebrow">AI Real Estate Network</p>
        <h2
          className="font-['Playfair_Display'] leading-[1.1] mb-5 text-3xl xl:text-4xl 2xl:text-5xl font-semibold"
          style={{ color: '#FFFFFF', wordBreak: 'normal', overflowWrap: 'break-word', maxWidth: '32rem', textShadow: '0 2px 12px rgba(0,0,0,0.4)' }}
          data-testid="login-hero-heading"
        >
          Welcome back to
          <span className="italic block mt-2" style={{ color: '#D4AF37' }}>your network.</span>
        </h2>
        <p className="text-sm xl:text-base max-w-md" style={{ color: 'rgba(255,255,255,0.85)' }}>High-trust auth, country-aware compliance, and AI-matched warm leads — all behind one tap.</p>
      </div>
    </div>
  </div>
);

export default LoginPage;
